import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.476 2.893a1 1 0 1 0-1.46 1.367L11.578 7 9.015 9.74a1 1 0 0 0 1.46 1.367l3.204-3.424a1 1 0 0 0 0-1.366zM4.985 4.26a1 1 0 1 0-1.46-1.367L.32 6.317a1 1 0 0 0 0 1.366l3.203 3.424a1 1 0 1 0 1.46-1.367L2.422 7z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const programmingScriptCode = { render };
export {
  programmingScriptCode as default,
  render
};
//# sourceMappingURL=programming-script-code.svg.js.map
